/* MUTE Toast — globales Notification-System (Phase 5.5.3, 2026-06-01)
   API: window.MuteToast.show(message, type, opts)
     type: 'success' | 'error' | 'info' (default 'info')
     opts: { action: { label, href }, duration (ms, default 4000) }
   A11y: role=status, aria-live=polite, prefers-reduced-motion respektiert.
   Selbst-initialisierend (eigener Container) — kein Dawn-Vendor-Edit nötig.
   Erfolgs-Toast hört auf 'mute:cart:added' (von mute-pdp.js dispatched). */
(function () {
  'use strict';
  if (window.MuteToast) return;

  var STYLE_ID = 'mute-toast-style';
  var REGION_ID = 'mute-toast-region';

  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var css =
      '#' + REGION_ID + '{position:fixed;left:50%;bottom:clamp(16px,4vw,28px);transform:translateX(-50%);' +
      'z-index:2147483000;display:flex;flex-direction:column;gap:8px;width:min(420px,calc(100vw - 32px));pointer-events:none;}' +
      '.mute-toast{pointer-events:auto;display:flex;align-items:center;gap:12px;' +
      'min-height:44px;padding:12px 14px;border:1px solid var(--mute-text-primary,#0A0A0A);' +
      'background:var(--mute-bg-white,#FFFFFF);color:var(--mute-text-primary,#0A0A0A);' +
      'box-shadow:0 6px 24px rgba(0,0,0,.14);transform:translateY(12px);opacity:0;' +
      'transition:transform 180ms ease,opacity 180ms ease;overflow-wrap:anywhere;}' +
      '.mute-toast.is-in{transform:translateY(0);opacity:1;}' +
      '.mute-toast__msg{flex:1 1 auto;font-family:var(--mute-font-body,"Inter",sans-serif);' +
      'font-size:clamp(14px,1.6vw,15px);line-height:1.4;margin:0;}' +
      '.mute-toast__action{flex:0 0 auto;min-height:44px;display:inline-flex;align-items:center;' +
      'padding:6px 12px;text-decoration:none;font-family:var(--mute-font-mono,"JetBrains Mono",monospace);' +
      'font-size:13px;font-weight:700;letter-spacing:.03em;color:var(--mute-bg-white,#FFFFFF);' +
      'background:var(--mute-text-primary,#0A0A0A);white-space:nowrap;}' +
      '.mute-toast__action:hover{background:var(--mute-signal-red,#FF4D2E);}' +
      '.mute-toast__action:focus-visible{outline:3px solid var(--mute-signal-red,#FF4D2E);outline-offset:2px;}' +
      '.mute-toast__close{flex:0 0 auto;min-height:44px;min-width:44px;cursor:pointer;border:0;background:transparent;' +
      'color:var(--mute-text-meta,#595959);font-size:20px;line-height:1;font-family:inherit;}' +
      '.mute-toast__close:focus-visible{outline:3px solid var(--mute-signal-red,#FF4D2E);outline-offset:2px;}' +
      '.mute-toast--success{border-left:4px solid #1F8A4C;}' +
      '.mute-toast--error{border-left:4px solid var(--mute-signal-red,#FF4D2E);}' +
      '.mute-toast--info{border-left:4px solid var(--mute-text-primary,#0A0A0A);}' +
      '@media (prefers-reduced-motion: reduce){.mute-toast{transition:opacity 120ms ease;transform:none;}.mute-toast.is-in{transform:none;}}';
    var st = document.createElement('style');
    st.id = STYLE_ID;
    st.textContent = css;
    document.head.appendChild(st);
  }

  function region() {
    var r = document.getElementById(REGION_ID);
    if (!r) {
      r = document.createElement('div');
      r.id = REGION_ID;
      r.setAttribute('role', 'status');
      r.setAttribute('aria-live', 'polite');
      r.setAttribute('aria-atomic', 'true');
      (document.body || document.documentElement).appendChild(r);
    }
    return r;
  }

  function show(message, type, opts) {
    if (!message) return;
    injectStyle();
    opts = opts || {};
    type = type || 'info';
    var dur = typeof opts.duration === 'number' ? opts.duration : 4000;

    var el = document.createElement('div');
    el.className = 'mute-toast mute-toast--' + type;

    var msg = document.createElement('p');
    msg.className = 'mute-toast__msg';
    msg.textContent = message;
    el.appendChild(msg);

    if (opts.action && opts.action.href && opts.action.label) {
      var a = document.createElement('a');
      a.className = 'mute-toast__action';
      a.href = opts.action.href;
      a.textContent = opts.action.label;
      el.appendChild(a);
    }

    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'mute-toast__close';
    close.setAttribute('aria-label', 'Schließen');
    close.innerHTML = '&times;';
    el.appendChild(close);

    var reg = region();
    reg.appendChild(el);
    requestAnimationFrame(function () { el.classList.add('is-in'); });

    var timer;
    function dismiss() {
      if (timer) clearTimeout(timer);
      el.classList.remove('is-in');
      setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 220);
    }
    close.addEventListener('click', dismiss);
    if (dur > 0) timer = setTimeout(dismiss, dur);
    return dismiss;
  }

  window.MuteToast = { show: show };

  /* Erfolgs-Toast nach ATC (mute-pdp.js dispatched 'mute:cart:added') */
  document.addEventListener('mute:cart:added', function () {
    show('Drin. Liegt im Warenkorb.', 'success', {
      action: { label: 'Zum Warenkorb →', href: '/cart' },
      duration: 5000
    });
  });
})();
